export default __webpack_public_path__ + "static/media/default_white@1x.048fff0d.webp";